import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "salary-result-statistics" }
const _hoisted_2 = {
  key: 1,
  class: "salary-result-statistics__stats-cards"
}

import SalaryStatCard from "@shared/components/salary-stat-card/SalaryStatCard.vue";
import InfoBox from "@shared/components/info-box/InfoBox.vue";
import Selections from "@shared/components/selections/Selections.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SalaryResultsStatistics',
  props: {
    statistics: {},
    values: { default: () => [] },
    valuesLabel: { default: null },
    formatValues: { type: Boolean, default: true },
    p10Label: { default: '' },
    medianLabel: { default: '' },
    averageLabel: { default: '' },
    p90Label: { default: '' },
    insufficientDataTitle: { default: '' },
    insufficientDataText: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.values?.length)
      ? (_openBlock(), _createBlock(Selections, {
          key: 0,
          label: __props.valuesLabel,
          values: __props.values,
          formatValues: __props.formatValues,
          small: true
        }, null, 8 /* PROPS */, ["label", "values", "formatValues"]))
      : _createCommentVNode("v-if", true),
    (__props.statistics.hasEnoughData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SalaryStatCard, {
            number: __props.statistics.p10,
            label: __props.p10Label
          }, null, 8 /* PROPS */, ["number", "label"]),
          _createVNode(SalaryStatCard, {
            number: __props.statistics.median,
            label: __props.medianLabel
          }, null, 8 /* PROPS */, ["number", "label"]),
          _createVNode(SalaryStatCard, {
            number: __props.statistics.average,
            label: __props.averageLabel
          }, null, 8 /* PROPS */, ["number", "label"]),
          _createVNode(SalaryStatCard, {
            number: __props.statistics.p90,
            label: __props.p90Label
          }, null, 8 /* PROPS */, ["number", "label"])
        ]))
      : (_openBlock(), _createBlock(InfoBox, {
          key: 2,
          strongText: __props.insufficientDataTitle,
          text: __props.insufficientDataText,
          slim: true
        }, null, 8 /* PROPS */, ["strongText", "text"]))
  ]))
}
}

})